import { axInstBasic } from "../../components/Service/Service";

export const fetchFaultcodeData = async (parArn,childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}getFaultCodeAnalysis`,{parArn,childArn}
    );
    
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

